// extracted by css-extract-rspack-plugin
export default {"Box":"EditIssues-module__Box__LUzymam","Octicon":"EditIssues-module__Octicon__FdXrslS","Text":"EditIssues-module__Text__j_S6bxs","Text_1":"EditIssues-module__Text_1__magh5B8"};